const faqs = [
  {
    "question_en": "How do I book a room or event space in SPORTI?",
    "question_ka": "ನಾನು ಸ್ಪೊರ್ಟಿ-1 ಅಥವಾ ಸ್ಪೊರ್ಟಿ-2 ನಲ್ಲಿ ಕೋಣೆ ಅಥವಾ ಈವೆಂಟ್ ಸ್ಥಳವನ್ನು ಹೇಗೆ ಬುಕ್ ಮಾಡಬಹುದು?",
    "answer_en": "To book a room or event space, first you need to be a member of SPORTI. Next step is go to SPORTI-1 or SPORTI-2 page, select desired service, fill in the required details and submit request for approval.",
    "answer_ka": "ವೇಬ್ಸೈಟ್ ಅನ್ನು ಬಳಸಿಕೊಂಡು ಕೋಣೆ ಅಥವಾ ಈವೆಂಟ್ ಸ್ಥಳವನ್ನು ಬುಕ್ ಮಾಡಲು, ನೀವು ಸ್ಪೊರ್ಟಿ ಸದಸ್ಯರಾಗಿರಬೇಕು. ಲಾಗಿನ್ ಮಾಡಿ ಅಥವಾ ಖಾತೆ ಸೃಷ್ಟಿಸಿ, ನಿಮ್ಮ ಇಚ್ಛಿತ ದಿನಾಂಕಗಳು ಮತ್ತು ಸ್ಥಳವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ, ನಿಮ್ಮ ಕೋಣೆ ಅಥವಾ ಈವೆಂಟ್ ಸ್ಥಳವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ, ಮತ್ತು ಪಾವತಿ ಮತ್ತು ಸಂಪರ್ಕ ಮಾಹಿತಿಯನ್ನು ನಮೂದಿಸಿ."
  },
  {
    "question_en": "Can I cancel or modify my booking?",
    "question_ka": "ನಾನು ನನ್ನ ಬುಕ್ಕಿಂಗ್ ಅನ್ನು ರದ್ದುಪಡಿಸಬಹುದೇ ಅಥವಾ ತಿದ್ದುಪಡಿ ಮಾಡಬಹುದೇ?",
    "answer_en": "This depends on the SPORTI cancellation policy. Some bookings may be non-refundable, while others may allow for free cancellation or modifications up to a certain date. Check the cancellation policy before making your booking.",
    "answer_ka": "ಇದು ಸ್ಪೊರ್ಟಿ ರದ್ದುಪಡಿಸುವ ನೀತಿಗೆ ಅವಲಂಬಿತವಾಗಿದೆ. ಕೆಲವು ಬುಕ್ಕಿಂಗ್‌ಗಳನ್ನು ಮರುಪಾವತಿಸದಿರಬಹುದು, ಇನ್ನು ಕೆಲವು ನಿಗದಿತ ದಿನಾಂಕದವರೆಗೆ ಉಚಿತ ರದ್ದುಪಡಿಸುವಿಕೆ ಅಥವಾ ತಿದ್ದುಪಡಿಗಳನ್ನು ಅನುಮತಿಸಬಹುದು. ನಿಮ್ಮ ಬುಕ್ಕಿಂಗ್ ಮಾಡುವ ಮೊದಲು ರದ್ದುಪಡಿಸುವ ನೀತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ."
  },
  {
    "question_en": "Can I request specific amenities or room types?",
    "question_ka": "ನಾನು ನಿರ್ದಿಷ್ಟ ಸೌಲಭ್ಯಗಳು ಅಥವಾ ಕೋಣೆ ಪ್ರಕಾರಗಳನ್ನು ಕೇಳಬಹುದೇ?",
    "answer_en": "Yes, SPORTI allows you to request specific amenities or room types.",
    "answer_ka": "ಹೌದು, ಸ್ಪೊರ್ಟಿ ನಿಮಗೆ ನಿರ್ದಿಷ್ಟ ಸೌಲಭ್ಯಗಳು ಅಥವಾ ಕೋಣೆ ಪ್ರಕಾರಗಳನ್ನು ಕೇಳಲು ಅನುಮತಿಸುತ್ತದೆ."
  },
  {
    "question_en": "How do I pay for booking?",
    "question_ka": "ಬುಕ್ಕಿಂಗ್‌ಗಾಗಿ ನಾನು ಹೇಗೆ ಪಾವತಿಸಬಹುದು?",
    "answer_en": "Payment methods include credit card, debit card, cash payment, and UPI.",
    "answer_ka": "ಪಾವತಿ ವಿಧಾನಗಳಲ್ಲಿ ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್, ಡೆಬಿಟ್ ಕಾರ್ಡ್, ನಗದು ಪಾವತಿ ಮತ್ತು ಯುಪಿಐ ಸೇರಿವೆ."
  },
  {
    "question_en": "Can I view photos and reviews of the room or event space before booking?",
    "question_ka": "ನಾನು ಬುಕ್ಕಿಂಗ್ ಮಾಡುವ ಮೊದಲು ಕೋಣೆ ಅಥವಾ ಈವೆಂಟ್ ಸ್ಥಳದ ಫೋಟೋಗಳು ಮತ್ತು ವಿಮರ್ಶೆಗಳನ್ನು ನೋಡಬಹುದೇ?",
    "answer_en": "Yes, SPORTI allows you to view photos and read reviews of the event space before booking.",
    "answer_ka": "ಹೌದು, ಸ್ಪೊರ್ಟಿ ನಿಮಗೆ ಫೋಟೋಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಮತ್ತು ಈವೆಂಟ್ ಸ್ಥಳದ ವಿಮರ್ಶೆಗಳನ್ನು ಓದಲು ಅನುಮತಿಸುತ್ತದೆ."
  },
  {
    "question_en": "How do I contact Help Desk if I have an issue with the booking?",
    "question_ka": "ಬುಕ್ಕಿಂಗ್‌ನಲ್ಲಿ ನನ್ನಿಗೆ ಸಮಸ್ಯೆ ಇದ್ದರೆ ನಾನು ಸಹಾಯ ಡೆಸ್ಕ್ ಅನ್ನು ಹೇಗೆ ಸಂಪರ್ಕಿಸಬಹುದು?",
    "answer_en": [
      {
        "SPORTI": "SPORTI-1",
        "contact_number": "+91 8277945903",
        "email": "sportikarnataka@gmail.com"
      },
      {
        "SPORTI": "SPORTI-2",
        "contact_number": "+91 8618363693",
        "email": "sporti2gov@gmail.com"
      }
    ],
    "answer_ka": [
      {
        "SPORTI": "ಸ್ಪೊರ್ಟಿ 1",
        "contact_number": "+91 8277945903",
        "email": "sportikarnataka@gmail.com"
      },
      {
        "SPORTI": "ಸ್ಪೊರ್ಟಿ 2",
        "contact_number": "+91 8618363693",
        "email": "sporti2gov@gmail.com"
      }
    ]
  },
  {
    "question_en": "Can I book more than 1 room?",
    "question_ka": "ನಾನು ಒಂದಕ್ಕಿಂತ ಹೆಚ್ಚು ಕೋಣೆ ಬುಕ್ ಮಾಡಬಹುದೇ?",
    "answer_en": "If you are booking 3 or more rooms, you must pay 50% of the total amount in advance.",
    "answer_ka": "ನೀವು 3 ಅಥವಾ ಹೆಚ್ಚು ಕೋಣೆಗಳನ್ನು ಬುಕ್ ಮಾಡುತ್ತಿದ್ದರೆ, ನೀವು ಒಟ್ಟು ಮೊತ್ತದ 50% ಮುಂಗಡ ಪಾವತಿಸಬೇಕು."
  },
  {
    "question_en": "Can anyone use the facilities at SPORTI?",
    "question_ka": "ಯಾರಾದರೂ ಸ್ಪೊರ್ಟಿ ಸೌಲಭ್ಯಗಳನ್ನು ಬಳಸಬಹುದೇ?",
    "answer_en": "No, SPORTI services are reserved only for Senior Police Department Officers.",
    "answer_ka": "ಇಲ್ಲ, ಸ್ಪೊರ್ಟಿ ಸೇವೆಗಳು ಮಾತ್ರ ಹಿರಿಯ ಪೊಲೀಸ್ ಇಲಾಖೆ ಅಧಿಕಾರಿಗಳಿಗೆ ಮೀಸಲಾಗಿವೆ."
  },
  {
    "question_en": "What facilities are available in the room?",
    "question_ka": "ಕೋಣೆಯಲ್ಲಿ ಲಭ್ಯವಿರುವ ಸೌಲಭ್ಯಗಳು ಯಾವುವು?",
    "answer_en": "Facilities include free Wi-Fi, cupboards with hangers, fresh towels, blankets, hot water kettle, safety lockers, toiletries, and chargeable laundry services.",
    "answer_ka": "ಸೌಲಭ್ಯಗಳಲ್ಲಿ ಉಚಿತ ವೈ-ಫೈ, ಹ್ಯಾಂಗರ್‌ಗಳೊಂದಿಗೆ ಕಬೋರ್ಡ್‌ಗಳು, ತಾಜಾ ಟವೆಲ್‌ಗಳು, ಹಾಸು, ಬಿಸಿ ನೀರಿನ ಕೆಟಲ್, ಸುರಕ್ಷತಾ ಲಾಕರ್‌ಗಳು, ಶೌಚಾಲಯ ಸಾಮಾನುಗಳು ಮತ್ತು ಪಾವತಿಸಬಹುದಾದ ಲಾಂಡ್ರಿ ಸೇವೆಗಳು ಸೇರಿವೆ."
  },
  {
    "question_en": "Is there a Dining facility available at SPORTI?",
    "question_ka": "ಸ್ಪೊರ್ಟಿಯಲ್ಲಿ ಊಟ ಸೌಲಭ್ಯ ಲಭ್ಯವಿದೆಯೆ?",
    "answer_en": [
      {
        "SPORTI": "SPORTI 1",
        "description": "VRO Hospitality manages the Dining at SPORTI-1 and has Specialized cooks for North and South Indian Cuisines with a plethora of dishes to choose from."
      },
      {
        "SPORTI": "SPORTI 2",
        "description": "Breakfast, Lunch, Snacks, and Dinner are available at SPORTI-2 prepared by in-house chefs For Everyone who miss Home-cooked food."
      }
    ],
    "answer_ka": [
      {
        "SPORTI": "ಸ್ಪೊರ್ಟಿ 1",
        "description": "VRO ಹಾಸ್ಪಿಟಾಲಿಟಿ ಸ್ಪೊರ್ಟಿ-1 ನಲ್ಲಿ ಊಟವನ್ನು ನಿರ್ವಹಿಸುತ್ತದೆ ಮತ್ತು ಉತ್ತರ ಮತ್ತು ದಕ್ಷಿಣ ಭಾರತೀಯ ಅಡುಗೆಗಾಗಿ ವಿಶೇಷ ಅಡುಗೆಗಾರರನ್ನು ಹೊಂದಿದೆ, ಆಯ್ಕೆ ಮಾಡಲು ಅನೇಕ ತಿನಿಸುಗಳಿವೆ."
      },
      {
        "SPORTI": "ಸ್ಪೊರ್ಟಿ 2",
        "description": "ಸ್ಪೊರ್ಟಿ-2 ನಲ್ಲಿ ಇನ್-ಹೌಸ್ ಶೆಫ್‌ಗಳಿಂದ ತಯಾರಿಸಲಾದ ಬ್ರೇಕ್‌ಫಾಸ್ಟ್, ಲಂಚ್, ಸ್ನ್ಯಾಕ್ಸ್ ಮತ್ತು ಡಿನ್ನರ್ ಲಭ್ಯವಿದೆ, ಇದು ಮನೆ ಅಡುಗೆ ಆಹಾರವನ್ನು ಮಿಸ್ ಮಾಡಿಕೊಳ್ಳುವವರಿಗೆ."
      }
    ]
  },
  {
    "question_en": "Can Officers from non-Karnataka Cadre use facilities at SPORTI?",
    "question_ka": "ಕರ್ನಾಟಕ ಕೇಡರ್ ನಲ್ಲಿಲ್ಲದ ಅಧಿಕಾರಿಗಳು ಸ್ಪೊರ್ಟಿ ಸೌಲಭ್ಯಗಳನ್ನು ಬಳಸಬಹುದೇ?",
    "answer_en": "Yes, other Cadre officers can book rooms or use facilities through their batchmates working in Karnataka Cadre.",
    "answer_ka": "ಹೌದು, ಇತರ ಕೇಡರ್ ಅಧಿಕಾರಿಗಳು ಕರ್ನಾಟಕ ಕೇಡರ್‌ನಲ್ಲಿ ಕೆಲಸ ಮಾಡುತ್ತಿರುವ ತಮ್ಮ ಬ್ಯಾಚ್‌ಮೇಟ್ಸ್ ಮೂಲಕ ಕೋಣೆಗಳನ್ನು ಬುಕ್ ಮಾಡಬಹುದು ಅಥವಾ ಸೌಲಭ್ಯಗಳನ್ನು ಬಳಸಬಹುದು."
  },
  {
    "question_en": "Is there a Parking facility available?",
    "question_ka": "ಪಾರ್ಕಿಂಗ್ ಸೌಲಭ್ಯ ಲಭ್ಯವಿದೆಯೇ?",
    "answer_en": "Yes, a wide parking area is available at both SPORTI-1 and SPORTI-2.",
    "answer_ka": "ಹೌದು, ಸ್ಪೊರ್ಟಿ-1 ಮತ್ತು ಸ್ಪೊರ್ಟಿ-2 ರಲ್ಲಿ ವ್ಯಾಪಕ ಪಾರ್ಕಿಂಗ್ ಪ್ರದೇಶ ಲಭ್ಯವಿದೆ."
  }
]

export default faqs;
